  document.addEventListener("DOMContentLoaded", () => {
  if (typeof BlogAjax === "undefined") return;

  const grid = document.querySelector("#blog-cards-grid");
  const paginationWrap = document.querySelector("#blog-pagination");
  const chips = document.querySelectorAll(".js-blog-chip");
  const select = document.querySelector(".js-blog-taxonomy-select");

  if (!grid || !paginationWrap) return;

  const ajaxUrl = BlogAjax.ajaxUrl;
  const nonce = BlogAjax.nonce;
  const ppp = parseInt(BlogAjax.ppp, 10) || 2;

  let activeCat = 0;

  const setActiveChip = (cat) => {
    chips.forEach(btn => {
      btn.classList.toggle("is-active", parseInt(btn.dataset.cat, 10) === cat);
    });
  };

  const loadPosts = async ({cat = 0, paged = 1}) => {
    const formData = new FormData();
    formData.append("action", "blog_filter");
    formData.append("nonce", nonce);
    formData.append("cat", cat);
    formData.append("paged", paged);
    formData.append("ppp", ppp);

    const res = await fetch(ajaxUrl, {
      method: "POST",
      body: formData,
    });

    const json = await res.json();
    if (!json || !json.success) return;

    grid.innerHTML = json.data.cards_html || "";
    paginationWrap.innerHTML = json.data.pagination_html || "";
  };

  chips.forEach(btn => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();

      const cat = parseInt(btn.dataset.cat, 10) || 0;
      activeCat = cat;

      setActiveChip(cat);
      if (select) select.value = String(cat);

      await loadPosts({ cat, paged: 1 });
    });
  });

  if (select) {
    select.addEventListener("change", async () => {
      const cat = parseInt(select.value, 10) || 0;
      activeCat = cat;

      setActiveChip(cat);
      await loadPosts({ cat, paged: 1 });
    });
  }

  document.addEventListener("click", async (e) => {
    const a = e.target.closest(".blog__pagination a");
    if (!a) return;

    e.preventDefault();

    const href = a.getAttribute("href") || "";
    let paged = 1;

    if (href.includes("paged=")) {
      paged = parseInt(new URL(href).searchParams.get("paged"), 10) || 1;
    } else {
      paged = parseInt(href.match(/page\/(\d+)/)?.[1], 10) || 1;
    }

    await loadPosts({ cat: activeCat, paged });
  });
});